import { FormCommonProps } from "src/components/common/forms/types.ts";
import { AsyncForm } from "src/components/common/forms/AsyncForm.tsx";
import { Delivery } from "src/api/generated/erp/db/types/tables/delivery.ts";
import i18n from "i18next";
import { FormDateTimeField } from "src/components/common/forms/fields/FormDateTimeField.tsx";
import { DeliveryEditApiForCargoDriver } from "src/api/generated/erp/delivery/api/deliveryEditApiForCargoDriver.ts";
import { defineAgentUiContextKey } from "src/components/views/ai/assistant/uiContext/agentUiContextKey.ts";

export interface DeliveryFormWithCargoDriverProps extends FormCommonProps<number> {
	deliveryId: number;
}

interface FormValues extends Delivery {}

export const DeliveryFormWithCargoDriver = (props: DeliveryFormWithCargoDriverProps) => {
	const { onCompleted, onFormEdited, deliveryId } = props;

	return (
		<AsyncForm
			fetch={() =>
				DeliveryEditApiForCargoDriver.getFormInitData({
					deliveryId,
				})
			}
			getDefaultValues={({ delivery }) => delivery}
			submit={submit}
			onCompleted={onCompleted}
			onFormEdited={onFormEdited}
			agentContext={{
				key: defineAgentUiContextKey("erp.delivery.deliveryCargoDriver.form"),
				title: i18n.t("delivery"),
				pathSegments: [i18n.t("form")],
				data: { deliveryId },
			}}
			render={({ control }) => (
				<>
					<FormDateTimeField
						control={control}
						name={"plannedLoadingDate"}
						label={i18n.t("planned_loading_time")}
					/>
					<FormDateTimeField
						control={control}
						name={"plannedUnloadingDate"}
						label={i18n.t("planned_unloading_time")}
					/>
				</>
			)}
		/>
	);

	async function submit(values: FormValues) {
		await DeliveryEditApiForCargoDriver.update({ delivery: values });
		return deliveryId;
	}
};
